const PIXPERIN = 96;

export const inchesToPixes = inches => {
  return inches * PIXPERIN;
}

export const LABEL_FORMATS = {
  STANDARD: 'standard',
  ROLL: 'roll',
};

const standardStyles = {
  modal: `
    width: ${inchesToPixes(8.5)}px !important;
    height: 100% !important;
    top: 0;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;

    .ant-modal-content {
      box-shadow: none;
      margin: 0 !important;
      padding: 0 !important;
    }

    .ant-modal-body {
      padding: 0px !important;
      margin: 0 !important;
      margin-left: 12px !important;
    }

    @media print {
      @page {
        margin: ${inchesToPixes(0.5)}px 0;
      }
    }
  `,
  labelsContainer: `
    page-break-inside: avoid;
  `,
  labelContainer: `
    border: 2px solid black;
    margin: 0px 5px;
    padding: 10px;
    float: left;

    width: 3.98in;
    height: 3.32in;

    page-break-inside: avoid;
  `,
  logoContainer: `
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .Logo {
      filter: brightness(0) saturate(100%);
    }
    .Logo img {
      filter: none !important;
    }
  `,
  textContainer: `
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: 10px;
  `,
  col: `
    padding: 5px;
  `,
  row: ``,
  rowTitle: `
    font-size: 12px;
    font-weight: bold;
  `,
  rowValue: `
    font-size: 10px;
  `,
  printLabelsBtn: `
    input {
      width: 60px;
      margin-left: 10px;
    }
    .ant-select {
      margin-left: 10px;
    }
  `,
  approvaldate: `
    position: absolute;
    top: 2.44in;
    width: 100%;
    left: 0px;
    text-align: center;
    font-size: 12px;
  `,
  crossout: `
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M100 0 L0 100 ' stroke='red' stroke-width='1'/><path d='M0 0 L100 100 ' stroke='red' stroke-width='1'/></svg>");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%, auto;
    border: solid red 2px;
  `,
  printErrorContainer: `
    position: absolute;
    top: 100%;
    width: 80%;
    background-color: white;
    left: 10%;
    text-align: center;
    font-weight: bold;
    padding: 10px;
    border: 1px solid black;
  `
};

const rollStyles = {
  ...standardStyles,
  modal: `
    width: ${inchesToPixes(4)}px !important;
    height: 100% !important;
    top: 0;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;

    .ant-modal-content {
      box-shadow: none;
      margin: 0 !important;
      padding: 0 !important;
    }

    .ant-modal-body {
      padding: 0px !important;
      margin: 0 !important;
    }

    @media print {
      @page {
        size: 4in 4in;
        margin: 0;
      }
    }
  `,
  labelsContainer: `
    page-break-inside: avoid;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  `,
  labelContainer: `
    border: 1px solid black;
    margin: auto;
    padding: 0.12in 0.12in 0.34in 0.12in;
    box-sizing: border-box;
    position: relative;

    width: 4in;
    height: 4in;

    display: flex;
    flex-direction: column;
    align-items: center;

    page-break-inside: avoid;
    page-break-after: always;
  `,
  logoContainer: `
    width: 100%;
    flex: 0 0 0.7in;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .Logo {
      filter: brightness(0) saturate(100%);
      width: auto !important;
      height: 100% !important;
      max-width: 2.6in;
    }
    .Logo img {
      filter: none !important;
      width: auto !important;
      height: 100% !important;
      max-width: 100%;
      object-fit: contain;
    }
  `,
  textContainer: `
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 0.05in;
    min-height: 0;
  `,
  col: `
    padding: 0.04in 0.05in;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
  `,
  rowTitle: `
    font-size: 12px;
    font-weight: bold;
    line-height: 14px;
  `,
  rowValue: `
    font-size: 11px;
    line-height: 13px;
    margin-bottom: 3px;
  `,
  qrContainer: `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100% !important;
      height: auto !important;
      max-width: 1.8in;
      max-height: 1.8in;
      display: block;
    }
  `,
  approvaldate: `
    position: absolute;
    bottom: 0.08in;
    left: 0.12in;
    right: 0.12in;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    border-top: 1px solid black;
    padding-top: 0.05in;
  `,
};

export const getStyles = (format) => {
  return format === LABEL_FORMATS.ROLL ? rollStyles : standardStyles;
};

export const styles = standardStyles;
